export default {
  // 指令的定义 v-permission="['admin','editor']"
  inserted(el, binding, vNode) {
    // 获取当前路由
    const { meta } = vNode.context.$route
    // 获取当前用户的按钮权限
    const userAuth = meta.permissions
    const { value } = binding
    // 判断是否有权限 如果没有权限则移除dom
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value
      const hasPermission = userAuth.some(role => {
        return permissionRoles.includes(role)
      })
      if (!hasPermission) {
        // el.parentNode && el.parentNode.removeChild(el)
        el.style.display = 'none'; // 隐藏而非删除
      }
    } else {
      throw new Error(`请按照指令格式使用`)
    }
    // const all_permission = '*:*:*'
    // const permissions = store.getters && store.getters.permissions

    // if (value && value instanceof Array && value.length > 0) {
    //   const permissionFlag = value

    //   const hasPermissions = permissions.some(permission => {
    //     return all_permission === permission || permissionFlag.includes(permission)
    //   })

    //   if (!hasPermissions) {
    //     el.parentNode && el.parentNode.removeChild(el)
    //   }
    // } else {
    //   throw new Error(`请设置操作权限标签值`)
    // }
  }
}
